import { render } from "./ThirdAppDetail.vue?vue&type=template&id=644b6300&scoped=true"
import script from "./ThirdAppDetail.vue?vue&type=script&lang=js"
export * from "./ThirdAppDetail.vue?vue&type=script&lang=js"

import "./ThirdAppDetail.vue?vue&type=style&index=0&id=644b6300&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644b6300"]])

export default __exports__